module.exports = __webpack_public_path__ + "img/otp_crash_btn_bg.f48c5377.png";